<template>
<div>
  <div class="mask" v-show="flag"></div>
  <div class="login-box" v-show="flag">
    <svg t="1574148652848" class="icon" @click="closeDia" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1901" width="22" height="22"><path d="M559.5392 512l250.1888-250.1888a32.6912 32.6912 0 0 0 0-46.0544l-1.3824-1.3568a32.6912 32.6912 0 0 0-46.0544 0l-250.1632 250.4704-250.1888-250.5984a32.6912 32.6912 0 0 0-46.0544 0l-1.3568 1.3824a32.128 32.128 0 0 0 0 46.0544l250.1632 250.2656-250.1632 250.1888a32.6912 32.6912 0 0 0 0 46.0544l1.3568 1.3568a32.6912 32.6912 0 0 0 46.08 0l250.1632-250.1632 250.1632 250.1632a32.6912 32.6912 0 0 0 46.0544 0l1.3824-1.3568a32.6912 32.6912 0 0 0 0-46.0544l-250.1888-250.1888z" fill="#585858" p-id="1902"></path></svg>
    <div class="title">欢迎登录</div>
    <el-input v-model="phone" placeholder="请输入手机号" style="width:300px;margin-top:35px"></el-input>
    <div class="err-text">{{errText}}</div>
    <el-input type="password" v-model="password" placeholder="请输入登录密码" style="width:300px;"></el-input>
    <div class="err-text">{{passErrText}}</div>
    <div class="logbtn" @click="logbtn">登 录</div>
    <div class="line"></div>
    <div class="regbox">没有帐号？<span style="color:#2196F3;cursor:pointer" @click="registered"> 立即注册</span></div>
  </div>
</div>  
</template>

<script>
import BaseConfig from '@/common/baseConfig';
import publicAPI from '@/api/public';
import { Message } from 'element-ui';
import methods from '@/common/methods';


export default {
  name: 'headPage',
  props: {
    openFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      phone: '',
      password: '',
      errText: '',
      passErrText: '',
      flag: false,
    }
  },
  created() {
    this.flag = this.openFlag;
    console.log(this.openFlag);
  },
  methods: {
    closeDia() {
      this.flag = false;
      this.$emit('childFn', this.flag);
    },
    logbtn(){
      // window.open(BaseConfig.LOGIN_URL);
      if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
        this.errText = '请输入正确的手机号码'
        return;
      }else {
        this.errText = ''
      }
      if(this.password === '') {
        this.passErrText = '请输入登录密码'
        return;
      }else {
        this.passErrText = ''
      }
      const par = {
        tel: this.phone,
        pwd: this.password,
      }
      publicAPI.signin(par).then(({ error, id, session }) => {
        if(error === 'OK') {
          Message.success('登录成功');
          this.flag = false;
          sessionStorage.setItem('loginId',id);
          // sessionStorage.setItem('parsobj',parsobj);
          // methods.setCookie('session',session);
          const parsobj = {
              flag: this.flag,
              phone: this.phone
          };
          this.$emit('childFn', parsobj);
        }
      });
      
    },
    registered() {
        window.open(BaseConfig.REGIST_URL);
    },
    
  }
}
</script>
<style lang="stylus">
.el-input__inner
	border-radius 2px!important
</style>
<style  lang="stylus" scoped>
  @import "~common/stylus/loginPage.styl";
</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue